import BasicLayout from "../../layout/basic"
import {request} from "@/api/seo"
// import http from "@utils/http"
import Util from "@/utils/util"

const promotionRoutes = [
	//******************组合套餐模块（2）******************
	{
		path: "/promotion/combo-*",
		name: "combo",
		meta: {
			module: "combo"
		},
		component: () => import("@/views/promotion/combo/detail")
	},
	{
		path: "/promotion/combo_payment",
		name: "combo_payment",
		meta: {
			module: "combo",
			auth: true
		},
		component: () => import("@/views/promotion/combo/payment")
	},

	//******************秒杀模块（3）******************
	{
		path: "/promotion/seckill-*",
		name: "seckill_detail",
		meta: {
			module: "seckill",
			backgroundColor: "#fff"
		},
		component: () => import("@/views/promotion/seckill/detail")
	},
	{
		path: "/promotion/seckill",
		name: "seckill",
		meta: {
			module: "seckill",
			mainCss: {
				width: "100%"
			}
		},
		component: () => import("@/views/promotion/seckill/list")
	},
	{
		path: "/promotion/seckill_payment",
		name: "seckill_payment",
		meta: {
			module: "seckill",
			auth: true
		},
		component: () => import("@/views/promotion/seckill/payment")
	},

	//******************团购模块（3）******************
	{
		path: "/promotion/groupbuy-*",
		name: "groupbuy_detail",
		meta: {
			module: "groupbuy",
			backgroundColor: "#fff"
		},
		component: () => import("@/views/promotion/groupbuy/detail")
	},
	{
		path: "/promotion/groupbuy",
		name: "groupbuy",
		meta: {
			module: "groupbuy",
			mainCss: {
				width: "100%"
			}
		},
		component: () => import("@/views/promotion/groupbuy/list")
	},
	{
		path: "/promotion/groupbuy_payment",
		name: "groupbuy_payment",
		meta: {
			module: "groupbuy",
			auth: true
		},
		component: () => import("@/views/promotion/groupbuy/payment")
	},

	//******************专题活动模块（4）******************
	{
		path: "/promotion/topic-*",
		name: "topic_detail",
		meta: {
			module: "topic"
		},
		component: () => import("@/views/promotion/topic/detail")
	},
	{
		path: "/promotion/topic",
		name: "topic",
		meta: {
			module: "topic"
		},
		component: () => import("@/views/promotion/topic/list")
	},
	{
		path: "/promotion/topic-goods-*",
		name: "topic_goods_detail",
		meta: {
			module: "topic",
			backgroundColor: "#fff"
		},
		component: () => import("@/views/promotion/topic/goods_detail")
	},
	{
		path: "/promotion/topic_payment",
		name: "topic_payment",
		meta: {
			module: "topic",
			auth: true
		},
		component: () => import("@/views/promotion/topic/payment")
	}
]

const cmsRoutes = [{
		path: "/cms/notice",
		name: "notice",
		meta: {
			module: "notice",
			backgroundColor: "#fff"
		},
		component: () => import("@/views/cms/notice/list")
	},
	{
		path: "/cms/notice-*",
		name: "notice_detail",
		meta: {
			module: "notice",
			backgroundColor: "#fff"
		},
		component: () => import("@/views/cms/notice/detail")
	},
	{
		path: "/cms/help",
		name: "help",
		meta: {
			module: "help",
			backgroundColor: "#fff"
		},
		component: () => import("@/views/cms/help/list"),
		children: [{
			path: "/cms/help/listother-*",
			name: "list_other",
			meta: {
				module: "help",
				backgroundColor: "#fff"
			},
			component: () => import("@/views/cms/help/listother")
		}]
	},
	{
		path: "/cms/help-*",
		name: "help_detail",
		meta: {
			module: "help",
			backgroundColor: "#fff"
		},
		component: () => import("@/views/cms/help/detail")
	},
	//新闻资讯
	{
		path: "/news",
		name: "news",
		meta: {
			module: "news",
			backgroundColor: "#fff"
		},
		component: () => import("@/views/cms/news/index")
	},
	{
		path: "/news-detail-*",
		name: "news_detail",
		meta: {
			module: "news",
			backgroundColor: "#fff",
			title: '资讯'
		},
		beforeEnter (to, from, next) {
			request({
				'to':to,
			}).then(res => {
				window.seo = {
					to:to,
					data:res.data
				}
				// Util.seo(res.data)
				next();
			}).catch(res=>{
				next();
			})
		},
		component: () => import("@/views/cms/news/detail")
	},
	{
		path: "/news-list-*",
		name: "news_list",
		meta: {
			module: "news",
			backgroundColor: "#fff",
		},
		component: () => import("@/views/cms/news/list")
	},
	//展会 exhibit
	{
		path: "/exhibit",
		name: "exhibit",
		meta: {
			module: "exhibit",
			backgroundColor: "#fff"
		},
		component: () => import("@/views/cms/exhibit/index")
	},
	{
		path: "/exhibit-detail-*",
		name: "exhibit_detail",
		meta: {
			module: "exhibit",
			backgroundColor: "#fff"
		},
		component: () => import("@/views/cms/exhibit/detail")
	},
	{
		path: "/exhibit-list-*",
		name: "exhibit_list",
		meta: {
			module: "exhibit",
			backgroundColor: "#fff"
		},
		component: () => import("@/views/cms/exhibit/list")
	},
	//job 招聘
	{
		path: "/job",
		name: "job",
		meta: {
			module: "job",
			backgroundColor: "#fff"
		},
		component: () => import("@/views/cms/job/index")
	},
	{
		path: "/job-detail-*",
		name: "job_detail",
		meta: {
			module: "job",
			backgroundColor: "#fff"
		},
		component: () => import("@/views/cms/job/detail")
	},
	// {
	// 	path: "/job-list-*",
	// 	name: "job_list",
	// 	meta: {
	// 		module: "job",
	// 		backgroundColor: "#fff"
	// 	},
	// 	component: () => import("@/views/cms/job/list")
	// },
	//used 二手
	{
		path: "/used",
		name: "used",
		meta: {
			module: "used",
			backgroundColor: "#fff",
			title: '设备共享'
		},
		component: () => import("@/views/cms/used/index")
	},
	{
		path: "/used-detail-*",
		name: "used_detail",
		meta: {
			module: "used",
			backgroundColor: "#fff",
			title: '设备共享'
		},
		component: () => import("@/views/cms/used/detail")
	},
	//buy 求购
	{
		path: "/buy",
		name: "buy",
		meta: {
			module: "buy",
			backgroundColor: "#fff",
			title: '求购求租'
		},
		component: () => import("@/views/cms/buy/index")
	},
	{
		path: "/buy-detail-*",
		name: "buy_detail",
		meta: {
			module: "buy",
			backgroundColor: "#fff",
			title: '求购求租'
		},
		component: () => import("@/views/cms/buy/detail")
	},
	{
		path: "/company",
		name: "company",
		meta: {
			module: "shop",
			backgroundColor: "#fff",
			title: '公司'
		},
		component: () => import("@/views/cms/company/index")
	},
	{
		path: "/app",
		name: "app",
		meta: {
			module: "app",
			backgroundColor: "#fff",
			title: 'app'
		},
		component: () => import("@/views/cms/app/index")
	}
]

const goodsRoutes = [
	//******************商品模块（6）******************
	{
		path: "/brand",
		name: "brand",
		meta: {
			module: "goods",
			mainCss: {
				width: "100%"
			}
		},
		component: () => import("@/views/goods/brand")
	},
	{
		path: "/cart",
		name: "cart",
		meta: {
			module: "goods"
		},
		component: () => import("@/views/goods/cart")
	},
	{
		path: "/category",
		name: "category",
		meta: {
			module: "goods"
		},
		component: () => import("@/views/goods/category")
	},
	{
		path: "/coupon",
		name: "coupon",
		meta: {
			module: "goods"
		},
		component: () => import("@/views/goods/coupon")
	},
	{
		path: "/sku-*",
		name: "detail",
		meta: {
			module: "goods",
			backgroundColor: "#fff"
		},
		component: () => import("@/views/goods/detail")
	},
	{
		path: "/list",
		name: "list",
		meta: {
			module: "goods",
			title: '商品列表',
			backgroundColor: "#fff"
		},
		component: () => import("@/views/goods/list")
	},
	{
		path: "/street",
		name: "street",
		meta: {
			module: "shop",
			backgroundColor: "#fff",
			title: '店铺街'
		},
		component: () => import("@/views/shop/street")
	},
]

// 其他模块
export default {
	path: "/",
	component: BasicLayout,
	redirect: "/",
	name: "Index",
	children: [{
			path: "/",
			name: "index",
			alias:'/index',
			meta: {
				mainCss: {
					width: "100%"
				},
				title: ''
			},
			component: () => import("@/views/index/index")
		},
		{
			path: "/change_city",
			name: "change_city",
			meta: {
				module: "index"
			},
			component: () => import("@/views/index/change_city")
		},

		...goodsRoutes,
		...cmsRoutes,
		...promotionRoutes
	]
}
